export default __webpack_public_path__ + "static/media/gccMagazine@2x.d8d4865f.jpg";